import Framework7 from 'framework7/framework7.esm.bundle.js'
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js'
import 'framework7/css/framework7.css'
import 'framework7-icons/css/framework7-icons.css'
import '@/styles/f7-override.scss'

Framework7.use(Framework7Vue)
